<template>
  <div class="experimental"> 

    <b-navbar type="dark" variant="dark" fixed="top" toggleable="sm">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home" active> 🏢 </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item @click="$router.push('/maps')"><b-icon-map></b-icon-map> Maps</b-nav-item>
          <b-nav-item @click="$router.push('/data-warehouse')"><b-icon-building></b-icon-building> Data Warehouse</b-nav-item>
          <b-nav-item active><b-icon-egg-fried></b-icon-egg-fried> Experimental</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout()">
            <b-icon-box-arrow-left></b-icon-box-arrow-left> Logout {{username}}
            <b-avatar class="mr-3" size="1.3em"><v-gravatar :size="100" default-img="retro" :email="username" /></b-avatar>
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <main role="main" class="ml-sm-auto px-4">
      <b-card class="mb-2">
        <template v-slot:header>
          <div id="vegaEmbed"></div>
        </template>
        <b-card-text>
          Client side render with vega-embed
        </b-card-text>
      </b-card>
      
      <b-card class="mb-2">
        <template v-slot:header>
          <div id="vegaEmbedNoActions"></div>
        </template>
        <b-card-text>
          Client side render with vega-embed actions menu removed
        </b-card-text>
      </b-card>      
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Gravatar from 'vue-gravatar';
//import axios from "axios";
import vegaEmbed from "vega-embed";

Vue.component('v-gravatar', Gravatar);

import { IconsPlugin } from 'bootstrap-vue'
Vue.use(IconsPlugin)

export default {
  name: 'Experimental',
  data: function () {
    return {
    }
  },
  methods: {
    logout() {
      this.$router.push("/logout")
    },
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    }
  },
  mounted() {
    if (!this.$store.state.user) {
      this.$router.push("/about");
    }

    var barPlotSpec = {
      $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
      title: "LA Crime Count 2019 - 2020",
      data: {
        "values": [
            {"month": "2019 06", "Count of Crimes": 1302}, 
            {"month": "2019 07", "Count of Crimes": 1269}, 
            {"month": "2019 08", "Count of Crimes": 1363},
            {"month": "2019 09", "Count of Crimes": 1238}, 
            {"month": "2019 10", "Count of Crimes": 1226}, 
            {"month": "2019 11", "Count of Crimes": 1193},
            {"month": "2019 12", "Count of Crimes": 1289}, 
            {"month": "2020 01", "Count of Crimes": 1231}, 
            {"month": "2020 02", "Count of Crimes": 1233},
            {"month": "2020 03", "Count of Crimes": 1022}, 
            {"month": "2020 04", "Count of Crimes": 875}, 
            {"month": "2020 05", "Count of Crimes": 1087},
            {"month": "2020 06", "Count of Crimes": 580}
        ]
      },
      "width":300,
      "mark": {"type": "bar"},
      "encoding": {
          "color": {"value": "#FFA500"},
          "x": {"field": "month", "type": "ordinal"},
          "y": {"field": "Count of Crimes", "type": "quantitative"}
      }
    };

    vegaEmbed('#vegaEmbed', barPlotSpec);
    vegaEmbed('#vegaEmbedNoActions', barPlotSpec, {actions: false});
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
main {
  margin-bottom: 4.5rem;
  margin-top: 68px;
  text-align: left;
}

h1, h2, h3 {
  color: #990000;
}

.navbar.navbar-dark.bg-dark{
  background-color: #990000!important;
}

.app-icon {
  width: 32px;
  background-color: white;
  padding: 2px;
}
</style>
